import measuring from './measuring.jpg';

const Measuring = (): JSX.Element => (
    <img alt="Construction crew member using a measuring tape" src={measuring} />
);

export default Measuring;